module.exports = __webpack_public_path__ + "fonts/SpiritsNeutral-Black.5c7483e6.eot";